import { httpClient } from './httpClient'
import type { ApiResponse } from '../types'

export async function getPermissions(): Promise<ApiResponse<{ permissions: string[] }>> {
  try {
    const response = await httpClient
      .getClient()
      .get<{ permissions: string[] }>('/user/permissions')
    return { success: true, data: response.data }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Failed to fetch permissions',
      errorCode: error.code || 'UNKNOWN_ERROR',
      details: error.details,
    }
  }
}
